import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router } from "react-router-dom"
import { ApolloProvider } from "react-apollo";
import {client} from "./client";

import Dashboard2 from "views/Dashboard.jsx";

import "assets/scss/material-dashboard-pro-react.css?v=1.1.0";

import "../node_modules/react-select/dist/react-select.css";
import "../node_modules/fixed-data-table/dist/fixed-data-table.css";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/jquery/dist/jquery.min.js";

const hist = createBrowserHistory();


ReactDOM.render(
  <ApolloProvider client={client}> 
    <Router history={hist}>
      <Dashboard2 />
    </Router>
  </ApolloProvider>,
  document.getElementById("ui-container")
);


// WEBPACK FOOTER //
// ./src/index.js